export const mountableSteps = {
	stepLabel: "Paso",
	addStep: "Agregar nuevo paso",
	removeStep: "Eliminar paso",
	cardHeader: {
		titlePlaceholder: "Nombre del paso",
	},
	fields: {
		title: {
			label: "Título",
			placeholder: "Ingrese el título del paso",
		},
		pricing: {
			label: "Precios",
			placeholder: "Elija un método",
			options: {
				sum: {
					label: "Adicional",
					tooltip: "Todo elemento agregado será incrementado en el valor del producto",
				},
				average: {
					label: "Promedio",
					tooltip: "El promedio de los elementos seleccionados será incrementado",
				},
				higher: {
					label: "Mayor valor",
					tooltip:
						"El mayor valor entre los elementos será agregado al valor del producto",
				},
			},
		},
		min: {
			label: "Cant. min seleccionable del paso",
			tooltip: "Mínimo de artículos a seleccionar en este paso",
		},
		max: {
			label: "Cant. máx seleccionable del paso",
			tooltip: "Máximo de artículos a seleccionar en este paso",
		},
	},
	fiscalSplit: {
		enabled: "División de impuestos habilitada",
		disabled: "División de impuestos desactivada",
		title: "DIVISIÓN FISCAL",
		fiscalWeight: {
			label: "% Peso fiscal del paso {{stepNumber}}",
			placeholder: "00%",
			info: "El peso (%) determina cuánto representa este paso en la factura.",
			supplyAlert: {
				title: "Hay algunos insumos en este paso",
				message:
					"Cuando el paso tiene productos e insumos, el peso fiscal (%) solo define la participación de los productos con datos fiscales en la factura. Los insumos de arriba no tienen datos fiscales y no serán emitidos.",
			},
		},
		summary: {
			title: "Resumen fiscal",
			stepPrefix: "Paso",
			incomplete: "distribuya 100% entre los pasos",
		},
		dialog: {
			triggerLabel: "Saber más sobre la división fiscal",
			title: "División fiscal",
			paragraph1:
				"La división fiscal define cómo se distribuye el valor total de la factura entre los artículos del producto montable.",
			paragraph2: {
				intro:
					"Los pesos (%) de los pasos determinan la participación de los productos con datos fiscales en la factura.",
				bold:
					"Los insumos no tienen datos fiscales y no serán emitidos en la factura final.",
			},
			example: {
				title: "Ejemplo:",
				intro: "Una caipirinha de R$ 20:",
				item1: "Base (70%) — cachaça (producto con dato fiscal): R$ 14",
				item2: "Complementos (30%) — azúcar (insumo) y lima (insumo): no se emiten",
				conclusion:
					"En este caso, solo la cachaça participa en la división del valor de la factura.",
			},
			close: "Cerrar",
			confirm: "Entendido",
		},
	},
	itemsSection: {
		title: "ARTÍCULOS ADICIONALES",
		addItem: "Agregar otro artículo",
		removeItem: "Eliminar artículo",
		clearItem: "Limpiar artículo",
		fields: {
			item: {
				label: "Artículo",
				placeholder: "Seleccione un artículo",
				loadingPlaceholder: "Cargando productos...",
			},
			price: {
				label: "Precio",
			},
			maxCount: {
				label: "Cant. máx del artículo",
				placeholder: "0",
				tooltip:
					"Número máximo de veces que este artículo puede seleccionarse en el paso",
			},
			storageCount: {
				label: "Cant. descontada del artículo",
				placeholder: "0",
				tooltip: "Cantidad que se descontará del stock por unidad",
			},
			isModification: {
				label: "Artículo de modificación",
			},
		},
	},
	actions: {
		delete: "Eliminar producto montable",
		clear: "Limpiar producto montable",
		deleteConfirmation: {
			title: "Eliminar producto montable",
			description:
				"Al confirmar la acción elimina permanentemente el producto montable. ¿Desea continuar?",
			confirm: "Sí, deseo eliminar",
			cancel: "Cancelar",
		},
		clearConfirmation: {
			title: "Limpiar producto montable",
			description:
				"Al confirmar la acción limpiará todos los datos del producto montable del formulario. ¿Desea continuar?",
			confirm: "Sí, deseo limpiar",
			cancel: "Cancelar",
		},
		notifications: {
			deleteSuccess: "Producto montable eliminado correctamente",
			deleteError: "Error al eliminar el producto montable",
		},
	},
	preview: {
		toggle: {
			pdv: "PDV",
			totem: "Tótem",
		},
		productNameFallback: "Nombre del producto",
		descriptionFallback:
			"Agregue una descripción para el producto que se mostrará en el PDV o en el Tótem.",
		seeMore: "Ver más",
		requiredBadge: "Obligatorio",
		stepFallbackTitle: "Etapa {{n}}",
		itemFallbackName: "Artículo",
		chooseUpToOne: "Elija hasta {{count}} artículo",
		chooseUpToMany: "Elija hasta {{count}} artículos",
		addCta: "Agregar {{total}}",
		empty: {
			title: "Vista previa",
			description: "Las etapas aparecerán aquí a medida que complete el formulario.",
		},
		illustrativeNotice:
			"Esta es una vista previa ilustrativa y puede diferir de la visualización real en el PDV o el Tótem.",
		previewActionTooltip: "Solo vista previa — las acciones no están disponibles aquí.",
		expandPreview: "Ampliar vista previa",
	},
};
